import axios from 'axios';

const base = `${process.env.REACT_APP_API_URL}/ai`;

export function composeContent(token, { prompt, screenId, slotId, orientation }) {
  return axios.post(`${base}/compose`, { prompt, screenId, slotId, orientation }, {
    headers: { Authorization: token },
  });
}

export function sendCompositionMessage(token, compositionId, { message, orientation }) {
  return axios.post(`${base}/compose/${compositionId}/message`, { message, orientation }, {
    headers: { Authorization: token },
  });
}

export function getComposition(token, compositionId) {
  return axios.get(`${base}/compose/${compositionId}`, {
    headers: { Authorization: token },
  });
}

export function getCompositions(token) {
  return axios.get(`${base}/compositions`, {
    headers: { Authorization: token },
  });
}

export function getContentLibrary(token, userId) {
  const query = userId ? `?userId=${userId}` : '';
  return axios.get(`${base}/library${query}`, {
    headers: { Authorization: token },
  });
}

export function getAiSuggestions(token) {
  return axios.get(`${base}/suggestions`, {
    headers: { Authorization: token },
  });
}

export function dismissSuggestion(token, suggestionId) {
  return axios.post(`${base}/suggestions/${suggestionId}/dismiss`, {}, {
    headers: { Authorization: token },
  });
}

export function getAiProfile(token) {
  return axios.get(`${base}/profile`, {
    headers: { Authorization: token },
  });
}

export function updateAiProfile(token, profile) {
  return axios.put(`${base}/profile`, profile, {
    headers: { Authorization: token },
  });
}

export function publishComposition(token, compositionId, { screenIds, screenNames, slotId, userId }) {
  return axios.post(`${base}/compose/${compositionId}/publish`, { screenIds, screenNames, slotId, userId }, {
    headers: { Authorization: token },
  });
}

export function publishLibraryItem(token, itemId, { userId, screenIds, screenNames, slotId }) {
  return axios.post(`${base}/library/${itemId}/publish`, { userId, screenIds, screenNames, slotId }, {
    headers: { Authorization: token },
  });
}

export function sendChatMessage(token, { sessionId, message, attachments }) {
  return axios.post(`${base}/chat`, { sessionId, message, attachments }, {
    headers: { Authorization: token },
  });
}

export function uploadChatAttachment(token, { content, filename, mimeType }) {
  return axios.post(`${base}/chat/upload`, { content, filename, mimeType }, {
    headers: { Authorization: token },
  });
}

export function getChatSession(token, sessionId) {
  return axios.get(`${base}/chat/${sessionId}`, {
    headers: { Authorization: token },
  });
}

export function stopChatSession(token, sessionId) {
  return axios.post(`${base}/chat/${sessionId}/stop`, {}, {
    headers: { Authorization: token },
  });
}

export function startNewChatSession(token) {
  return axios.post(`${base}/chat/new`, {}, {
    headers: { Authorization: token },
  });
}

export function getComposerSmsSettings(token) {
  return axios.get(`${base}/composer-sms-settings`, {
    headers: { Authorization: token },
  });
}

export function updateComposerSmsSettings(token, settings) {
  return axios.put(`${base}/composer-sms-settings`, settings, {
    headers: { Authorization: token },
  });
}
